import logoWhite from "@/assets/logo-white.png";
import { cn } from "@/lib/utils";

// Brand mark: white alternativeADV triangle on a dark chip (readable on light & dark themes)
export const LogoMark = ({ size = 36, className }) => (
  <div
    className={cn("rounded-md bg-zinc-950 grid place-items-center shrink-0", className)}
    style={{ width: size, height: size }}
    data-testid="brand-logo-mark"
  >
    <img
      src={logoWhite}
      alt="alternativeADV"
      className="object-contain"
      style={{ width: size * 0.72, height: size * 0.72 }}
    />
  </div>
);

export const BrandLockup = ({ size = 36, subtitle = "CRM FORMAZIONE ABILITANTE", className, subtitleClassName }) => (
  <div className={cn("flex items-center gap-2.5", className)}>
    <LogoMark size={size} />
    <div className="leading-none">
      <div className="font-heading font-extrabold tracking-tight">alternativeADV</div>
      <div className={cn("text-[10px] text-muted-foreground overline mt-0.5", subtitleClassName)}>{subtitle}</div>
    </div>
  </div>
);
